// extracted by mini-css-extract-plugin
export var editButton = "_oo-0";